import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../css/LoginPage.css"; // Import CSS file
import { collection, getDocs, query, where, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { setCurrentUser } from "../auth/session";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate(); // Initialize navigate hook

  const handleLogin = (e) => {
    e.preventDefault();

    // Simple validation
    if (!username || !password) {
      setError("Both fields are required!");
      return;
    }

    (async () => {
      const u = String(username || "").trim().toLowerCase();
      const p = String(password || "").trim();

      try {
        // Prefer Firestore-based users (appUsers). This is the source of truth.
        const qRef = query(collection(db, "appUsers"), where("username", "==", u));
        const snap = await getDocs(qRef);
        if (!snap.empty) {
          const d = snap.docs[0];
          const data = d.data() || {};
          if (data.active === false) {
            setError("This user is inactive.");
            return;
          }
          if (String(data.pin || "") !== p) {
            setError("Invalid credentials!");
            return;
          }

          setCurrentUser({
            id: d.id,
            username: data.username || u,
            role: data.role || "user",
          });
          setError("");
          navigate("/home");
          return;
        }

        // Legacy fallback: allow the hardcoded admins to log in *only if* appUsers is empty.
        const allUsersSnap = await getDocs(collection(db, "appUsers"));
        const legacy = [
          { username: "whitewolf", pin: "1234567", role: "admin" },
          { username: "cobra", pin: "1234567", role: "admin" },
          { username: "winniepooh", pin: "1234567", role: "admin" },
        ];
        const match = legacy.find((x) => x.username === u && x.pin === p);
        if (match && allUsersSnap.empty) {
          // Bootstrap: create the first admin user in Firestore so you can manage users from the app.
          const ref = await addDoc(collection(db, "appUsers"), {
            username: match.username,
            pin: match.pin,
            role: match.role,
            active: true,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
            bootstrappedFromLegacy: true,
          });
          setCurrentUser({ id: ref.id, username: match.username, role: match.role });
          setError("");
          navigate("/home");
          return;
        }

        setError("Invalid credentials!");
      } catch (err) {
        console.error("Login failed:", err);
        setError("Login failed. Check Firestore rules / connection.");
      }
    })();
  };

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Login</h2>
        {error && <p className="error-message">{error}</p>}
        <div className="form-group">
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your username"
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
          />
        </div>
        <button type="submit" className="login-button">
          Login
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
